export const useButton = ({ onClick, disabled }) => {
  const handleClick = (e) => {
    if (disabled) {
      e.preventDefault();
      return;
    }
    if (onClick) {
      onClick(e);
    }
  };

  return {
    handleClick,
  };
};



// WEBPACK FOOTER //
// ./src/design-system/atoms/Button/hooks/useButton.js